import { ReportPage } from "@/pages/reports";

export function DashboardPage(): JSX.Element {
  return <ReportPage report="executive" />;
}
